import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Button from 'flarum/common/components/Button';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
export default function extendDiscussionControls() {
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (!discussion.canMerge()) return;
    items.add('fof-merge', m(Button, {
      icon: "fas fa-code-branch fa-flip-vertical",
      onclick: () => app.modal.show(() => import(/* webpackChunkName: 'forum/components/DiscussionMergeModal', webpackMode: 'lazy-once' */ './components/DiscussionMergeModal'), {
        discussion
      })
    }, app.translator.trans('fof-merge-discussions.forum.discussion.merge')));
  });
}flarum.reg.addChunkModule('375', '815', 'fof-merge-discussions', 'forum/components/DiscussionMergeModal');
flarum.reg.addChunkModule('375', '815', 'fof-merge-discussions', 'forum/components/DiscussionSearch');
flarum.reg.addChunkModule('375', '815', 'fof-merge-discussions', 'forum/components/DiscussionSearchSource');